import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 12 12",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M7.75 3.08333C8.39433 3.08333 8.91667 3.60567 8.91667 4.25M11.25 4.25C11.25 6.183 9.683 7.75 7.75 7.75C7.3964 7.75 7.05505 7.69756 6.73329 7.60004L5.41667 8.91667H4.25V10.0833H3.08333V11.25H1.33333C1.01117 11.25 0.75 10.9888 0.75 10.6667V9.15829C0.75 9.00358 0.811458 8.85521 0.920854 8.74581L4.39996 5.26671C4.30244 4.94495 4.25 4.6036 4.25 4.25C4.25 2.317 5.817 0.75 7.75 0.75C9.683 0.75 11.25 2.317 11.25 4.25Z",
      fill: "#CF6679",
      stroke: "#071830",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }